var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _line, _path4, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 3V3C11.4404 3 12 3.55964 12 4.25V17C12 18.1046 11.1046 19 10 19H4C2.89543 19 2 18.1046 2 17V4.25C2 3.55964 2.55964 3 3.25 3V3",
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6H16C17.1046 6 18 6.89543 18 8V14C18 15.1046 17.1046 16 16 16H13",
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 6,
    height: 2,
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.30078,
    y: 10.3604,
    width: 1.27836,
    height: 1.27836,
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.30078,
    y: 13.1133,
    width: 1.27836,
    height: 1.27836,
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.30078,
    y: 15.8672,
    width: 1.27836,
    height: 1.27836,
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.15234,
    y: 10.3604,
    width: 1.27836,
    height: 1.27836,
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.15234,
    y: 13.1133,
    width: 1.27836,
    height: 1.27836,
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.15234,
    y: 15.8672,
    width: 1.27836,
    height: 1.27836,
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.00391,
    y: 10.3604,
    width: 1.27836,
    height: 1.27836,
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.00391,
    y: 13.1133,
    width: 1.27836,
    height: 1.27836,
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.00391,
    y: 15.8672,
    width: 1.27836,
    height: 1.27836,
    stroke: "#734F07",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75391 1L4.08285 0.623446C3.93516 0.494422 3.72567 0.463657 3.54711 0.544767C3.36856 0.625877 3.25391 0.803885 3.25391 1L3.75391 1ZM4.78991 1.90503L4.46097 2.28159C4.64938 2.44618 4.93045 2.44618 5.11886 2.28159L4.78991 1.90503ZM5.82592 1L6.15487 0.623446C5.96646 0.458851 5.68539 0.458851 5.49697 0.623446L5.82592 1ZM6.86193 1.90503L6.53298 2.28159C6.7214 2.44618 7.00246 2.44618 7.19088 2.28159L6.86193 1.90503ZM7.89794 1L8.22689 0.623446C8.03847 0.458851 7.7574 0.458851 7.56899 0.623446L7.89794 1ZM8.93395 1.90503L8.605 2.28159C8.79341 2.44618 9.07448 2.44618 9.26289 2.28159L8.93395 1.90503ZM9.96995 1H10.47C10.47 0.803885 10.3553 0.625877 10.1767 0.544767C9.99819 0.463657 9.7887 0.494422 9.64101 0.623446L9.96995 1ZM9.46995 5.54493C9.46995 5.82108 9.69381 6.04493 9.96995 6.04493C10.2461 6.04493 10.47 5.82108 10.47 5.54493H9.46995ZM4.25391 5.54493V1H3.25391V5.54493H4.25391ZM3.42496 1.37655L4.46097 2.28159L5.11886 1.52848L4.08285 0.623446L3.42496 1.37655ZM5.11886 2.28159L6.15487 1.37655L5.49697 0.623446L4.46097 1.52848L5.11886 2.28159ZM5.49697 1.37655L6.53298 2.28159L7.19088 1.52848L6.15487 0.623446L5.49697 1.37655ZM7.19088 2.28159L8.22689 1.37655L7.56899 0.623446L6.53298 1.52848L7.19088 2.28159ZM7.56899 1.37655L8.605 2.28159L9.26289 1.52848L8.22689 0.623446L7.56899 1.37655ZM9.26289 2.28159L10.2989 1.37655L9.64101 0.623446L8.605 1.52848L9.26289 2.28159ZM9.46995 1V5.54493H10.47V1H9.46995Z",
    fill: "#734F07"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.08008,
    y1: 5.71191,
    x2: 10.7591,
    y2: 5.71191,
    stroke: "#734F07",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6L16 16",
    stroke: "#734F07",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 12.5,
    x2: 14.5,
    y2: 14.5,
    stroke: "#734F07",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 7.5,
    x2: 14.5,
    y2: 10.5,
    stroke: "#734F07",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosInProgress);
export default __webpack_public_path__ + "static/media/pos-in-progress.db71cb95a7ca6ff9df6454de9dcbc480.svg";
export { ForwardRef as ReactComponent };